import * as React from 'react';
import { RadioButton } from '@wix/social-groups-common';
import styles from './GroupSettings.st.css';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { ApiTypes } from '@wix/social-groups-api/dist/src/types';

interface GroupPermissionsProps {
  memberPermission: ApiTypes.v1.RoleInGroup;
  onChange(permission: ApiTypes.v1.RoleInGroup);
}

const mapRoleInGroupKeys: { [key in ApiTypes.v1.RoleInGroup]: string } = {
  [ApiTypes.v1.RoleInGroup.GROUP_MEMBER]:
    'groups-web.settings.permissions.all-members',
  [ApiTypes.v1.RoleInGroup.GROUP_ADMIN]:
    'groups-web.settings.permissions.admin-and-moderators',
  [ApiTypes.v1.RoleInGroup.SITE_ADMIN]: '',
};

const GroupPermissionsComponent: React.FunctionComponent<GroupPermissionsProps> = (
  props: GroupPermissionsProps & InjectedTranslateProps,
) => {
  const { t, memberPermission, onChange } = props;
  return (
    <>
      <Text
        typography={TYPOGRAPHY.runningText}
        tagName={'span'}
        {...styles(styles.smallCaption)}
      >
        {t('groups-web.settings.permissions.caption')}
      </Text>
      {[
        ApiTypes.v1.RoleInGroup.GROUP_MEMBER,
        ApiTypes.v1.RoleInGroup.GROUP_ADMIN,
      ].map(role => {
        return (
          <RadioButton
            key={role}
            text={t(mapRoleInGroupKeys[role])}
            checked={memberPermission === role}
            value={role}
            name="group-permission"
            onChange={onChange}
          />
        );
      })}
    </>
  );
};

export const GroupPermissions = translate()(
  GroupPermissionsComponent,
) as React.ComponentType<GroupPermissionsProps>;
GroupPermissions.displayName = 'GroupPermissions';
